import { defineMessages } from 'react-intl';

export default defineMessages({
  invalidEmailErrorMessage: {
    id: 'hooks.useApplePaySession.invalidEmailErrorMessage',
    description: 'Invalid email format error',
    defaultMessage: 'Invalid email format',
  },
  invalidStateErrorMessage: {
    id: 'hooks.useApplePaySession.invalidStateErrorMessage',
    description: 'Invalid state error',
    defaultMessage: 'Invalid state abbreviation',
  },
  defaultErrorMessage: {
    id: 'hooks.useApplePaySession.defaultErrorMessage',
    description: 'Default error message when invalid field',
    defaultMessage: 'Invalid {field}',
  },
});
